import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_PAYMENT_PLANS: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 150,
    type: 'action',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
      {
        name: 'print',
        iconName: 'download',
        showHideCondition: 'signedContractPath',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'srno',
    label: '#',
    width: 100,
    type: 'number',
  },
  // {
  //   dataKey: 'paymentPlanId',
  //   label: 'ID',
  //   width: 100,
  //   type: 'number',
  // },
  { dataKey: 'planName', label: 'Plan Name', width: 200, type: 'text' },
  {
    dataKey: 'patientId',
    label: 'Patient Id',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'patientname',
    label: 'Patient Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'templateName',
    label: 'Template',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'totalAmount',
    label: 'Total Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'initialAmount',
    label: 'Initial Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'paymentPlanAmount',
    label: 'Payment Plan Amt.',
    width: 200,
    type: 'currency',
  },
  {
    dataKey: 'remainingAmount',
    label: 'Remaining Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'receivedInstallmentAmount',
    label: 'Received Ins. Amt.',
    width: 200,
    type: 'currency',
  },
  // {
  //   dataKey: 'openPayment',
  //   label: 'Open Payment',
  //   width: 200,
  //   type: 'currency',
  // },
  {
    dataKey: 'installment',
    label: 'Amt. Per Ins.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'totalInstallments',
    label: 'Total Installments',
    width: 145,
    type: 'number',
  },
  {
    dataKey: 'pendingInstallments',
    label: 'Pending Installments',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'startDate',
    label: 'Start Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'nextPaymentDate',
    label: 'Next Payment',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'lastPaymentDate',
    label: 'Last Payment',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'lastEMIStatus',
    label: 'Last Payment Status',
    width: 200,
    type: 'status',
    tooltipDescriptionType: 'status-payment'
  },
  { dataKey: 'status', label: 'Status', width: 150, type: 'status' },
  {
    dataKey: 'isDigitalCopySavedString',
    label: 'Signed Copy',
    width: 200,
    type: 'text',
  },
];

export const TABLE_CONFIG_COLUMNS_PAYMENT_PLANS_DETAILS: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 150,
    type: 'action',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
      {
        name: 'print',
        iconName: 'print',
        showHideCondition: 'signedContractPath',
      },
    ],
    alignClass: 'text-start',
  },
  {
    dataKey: 'srno',
    label: '#',
    width: 100,
    type: 'number',
  },
  // {
  //   dataKey: 'paymentPlanId',
  //   label: 'ID',
  //   width: 100,
  //   type: 'number',
  // },
  { dataKey: 'planName', label: 'Plan Name', width: 200, type: 'text' },
  {
    dataKey: 'templateName',
    label: 'Template',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'totalAmount',
    label: 'Total Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'initialAmount',
    label: 'Initial Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'paymentPlanAmount',
    label: 'Payment Plan Amt.',
    width: 200,
    type: 'currency',
  },
  {
    dataKey: 'remainingAmount',
    label: 'Remaining Amt.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'receivedInstallmentAmount',
    label: 'Received Ins. Amt.',
    width: 200,
    type: 'currency',
  },
  // {
  //   dataKey: 'openPayment',
  //   label: 'Open Payment',
  //   width: 200,
  //   type: 'currency',
  // },
  {
    dataKey: 'installment',
    label: 'Amt. Per Ins.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'totalInstallments',
    label: 'Total Installments',
    width: 145,
    type: 'number',
  },
  {
    dataKey: 'pendingInstallments',
    label: 'Pending Installments',
    width: 150,
    type: 'number',
  },
  {
    dataKey: 'startDate',
    label: 'Start Date',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'nextPaymentDate',
    label: 'Next Payment',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'lastPaymentDate',
    label: 'Last Payment',
    width: 200,
    type: 'date',
  },
  {
    dataKey: 'lastEMIStatus',
    label: 'Last Payment Status',
    width: 200,
    type: 'status',
    tooltipDescriptionType: 'status-payment'
  },
  { dataKey: 'status', label: 'Status', width: 150, type: 'status' },
  {
    dataKey: 'isDigitalCopySavedString',
    label: 'Signed Copy',
    width: 150,
    type: 'text',
  },
];

export const PAYMENT_PLAN_STATUSES = {
  0: 'Active',
  1: 'Closed',
  2: 'Cancelled',
  //3: 'Failed',
};

export const PAYMENT_PLAN_EMI_STATUSES = {
  0: 'Pending',
  1: 'Paid',
  2: 'Overdue',
  3: 'Failed',
};

export const PAYMENT_PLAN_TYPES = {
  DIRECT: 'direct',
  INITIAL: 'initial',
};

export const TABLE_CONFIG_COLUMNS_PAYMENT_PLAN_REPORT: DyTableColumn[] = [
  {
    dataKey: 'planName',
    label: 'Plan Name',
    width: 200,
    type: 'text',
  },
  {
    dataKey: 'totalAmount',
    label: 'Payment Plan Amt',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'initialAmount',
    label: 'Initial Amt',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'remainingAmount',
    label: 'Remaining Amt',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'installment',
    label: 'Amt. Per Ins.',
    width: 150,
    type: 'currency',
  },
  {
    dataKey: 'noOfInstallments',
    label: 'Installments',
    width: 100,
    type: 'number',
  },
  {
    dataKey: 'startDate',
    label: 'Start Date',
    width: 200,
    type: 'date',
  },
];
